import React from 'react';
import {
  formatEmoteBubbleTwoWords,
  resolveBattleEmoteBubbleDisplay,
} from '../../utils/emoteSpeechI18n';
import {
  MOBILE_PLAYER_HUD_BOTTOM_PX,
  MOBILE_PLAYER_HUD_LEFT_PX,
  MOBILE_PLAYER_HUD_NATIVE_WIDTH_PX,
  MOBILE_PLAYER_HUD_SCALE,
} from '../mobile/mobileBattleLayoutOffsets';

const MOBILE_PLAYER_HUD_VISUAL_HEIGHT_PX = Math.round(160 * MOBILE_PLAYER_HUD_SCALE);

/**
 * Player emote speech bubble above the mobile player HUD.
 */
export default function BattlePlayerEmoteBubble({ bubble, t }) {
  if (!bubble) {
    return null;
  }

  const text = formatEmoteBubbleTwoWords(resolveBattleEmoteBubbleDisplay(bubble, t));

  return (
    <div
      style={{
        position: 'absolute',
        bottom: MOBILE_PLAYER_HUD_BOTTOM_PX + MOBILE_PLAYER_HUD_VISUAL_HEIGHT_PX + 8,
        left: MOBILE_PLAYER_HUD_LEFT_PX,
        zIndex: 10005,
        pointerEvents: 'none',
        maxWidth: Math.min(240, MOBILE_PLAYER_HUD_NATIVE_WIDTH_PX * MOBILE_PLAYER_HUD_SCALE + 20),
        minWidth: 96,
      }}
    >
      <div
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          border: '2px solid #40E0D0',
          borderRadius: '10px',
          padding: '8px 12px',
          boxShadow: '0 0 10px rgba(64, 224, 208, 0.6), 0 0 20px rgba(64, 224, 208, 0.4)',
          color: 'white',
          fontSize: '12px',
          fontWeight: 'bold',
          textAlign: 'center',
          lineHeight: 1.4,
          wordWrap: 'break-word',
          whiteSpace: 'pre-wrap',
        }}
      >
        {text}
      </div>
      <div
        aria-hidden
        style={{
          position: 'absolute',
          bottom: '-8px',
          left: '20px',
          width: 0,
          height: 0,
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderTop: '10px solid rgba(0, 0, 0, 0.85)',
          filter: 'drop-shadow(0 0 5px rgba(64, 224, 208, 0.6))',
        }}
      />
    </div>
  );
}
